export { default, default as Pill } from './Pill'
export { default as pillTheme } from './themes/Pill.theme'
export * as PillStyles from './styles/Pill.style'

export type { PillProps } from './Pill.types'
export type { AppearanceKeys, PillTheme } from './themes/Pill.theme.types'
export type { StyledPillProps } from './styles/Pill.style.types'
